import { API_URL } from './api';
import { PLAYGROUND_ORIGIN } from './playground-blueprint';

// Site ids are UUIDs; playground-host applies the same check to /view/ paths.
export function isValidSiteId(siteId: string): boolean {
  return /^[a-zA-Z0-9-]+$/.test(siteId);
}

// The view page downloads the snapshot with a short-lived token passed in
// the URL fragment, which is not sent to any server. `issued=1` tells the
// view page this URL came from the dashboard, so it shows an error instead
// of coming back here if the token can't be read.
export async function fetchViewSiteUrl(
  siteId: string,
  search = '',
): Promise<string> {
  const res = await fetch(
    `${API_URL}/api/v2/cloud/sites/${encodeURIComponent(siteId)}/view-token`,
    { method: 'POST', credentials: 'include' },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok || typeof data.token !== 'string') {
    throw new Error(data.error || `View token request failed: ${res.status}`);
  }
  const fragment = new URLSearchParams({ viewToken: data.token, issued: '1' });
  return `${PLAYGROUND_ORIGIN}/view/${encodeURIComponent(siteId)}${search}#${fragment.toString()}`;
}
